<template>
  <div class="tooltip-container" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>

    <div v-show="isVisible" class="tooltip" :class="position">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value)
    },
    show: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isVisible: false
    }
  },

  methods: {
    showTooltip() {
      if (!this.show) return
      this.isVisible = true
    },
    hideTooltip() {
      this.isVisible = false
    }
  }
}
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  background: #333;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.9em;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
  transition: opacity 0.2s;
}

/* Posicionamiento */
.tooltip.top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
}

.tooltip.bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
}

.tooltip.left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 8px;
}

.tooltip.right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 8px;
}

/* Flecha (opcional) */
.tooltip::after {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}

.top::after {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-color: #333 transparent transparent transparent;
}

.bottom::after {
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-color: transparent transparent #333 transparent;
}

.left::after {
  left: 100%;
  top: 50%;
  margin-top: -5px;
  border-color: transparent transparent transparent #333;
}

.right::after {
  right: 100%;
  top: 50%;
  margin-top: -5px;
  border-color: transparent #333 transparent transparent;
}
</style>